export const categories = [
  { id: "wanghong", name: "网红黑料", slug: "wanghong", description: "网红圈最新黑料爆料，全方位深扒网红人设翻车瞬间" },
  { id: "mingxing", name: "明星翻车", slug: "mingxing", description: "明星塌房第一现场，一手证据曝光不停歇" },
  { id: "redian", name: "热点事件", slug: "redian", description: "社会热点深度揭秘，还原事件真相" },
  { id: "bagua", name: "娱乐八卦", slug: "bagua", description: "娱乐圈最新八卦资讯，吃瓜群众聚集地" },
  { id: "shipin", name: "视频爆料", slug: "shipin", description: "实拍视频曝光，眼见为实的吃瓜体验" },
  { id: "shenba", name: "深度深扒", slug: "shenba", description: "深度调查揭秘，挖掘不为人知的真相" },
];

export const articles = [
  {
    id: 1,
    slug: "dingji-wanghong-renshe-bengta",
    title: "顶流网红人设崩塌：私生活混乱遭前女友实锤曝光",
    summary: "近日，某千万粉丝级顶流网红被前女友连发多条微博实锤，曝其私下与多名女粉丝保持暧昧关系，人设彻底崩塌...",
    content: `<p>近日，拥有超过2000万粉丝的顶流网红「X哥」遭遇了职业生涯最大危机。其前女友通过个人社交账号连续发布多条实锤内容，揭露了这位网红在光鲜人设背后的真实面目。</p><h2>事件起因</h2><p>据了解，前女友「小L」在与X哥交往两年后分手。分手原因据她透露，是发现X哥在交往期间同时与多名女粉丝保持暧昧关系，甚至存在多次线下约会行为。</p><h2>实锤内容曝光</h2><p>小L在爆料中公开了多张聊天记录截图、转账记录以及酒店入住凭证，时间跨度从2024年初至今。这些证据显示，X哥利用自己的网红身份，主动联系多名女粉丝并发展亲密关系。</p><p>更令人震惊的是，其中一位女粉丝当时尚未成年，这一细节引发了网友的强烈愤慨。</p><h2>粉丝反应两极化</h2><p>消息一出，X哥的粉丝群体迅速分化。一部分忠实粉丝坚决维护偶像，认为这是恶意抹黑；另一部分则表示极度失望，纷纷取关。</p><h2>后续发展</h2><p>目前X哥本人尚未对此事做出公开回应，但其团队已紧急启动公关流程。多位品牌方已暂停与其合作，预估经济损失达数千万。</p><p>51吃瓜爆料网将持续关注此事后续发展。</p>`,
    category: "wanghong",
    imageSeq: "article-wanghong-01",
    imageQuery: "Dark moody scene of social media influencer drama atmosphere with smartphone showing leaked chat messages on screen warm amber lighting shallow depth of field cinematic composition mysterious noir aesthetic high contrast editorial photography",
    publishedAt: "2026-07-05",
    author: "吃瓜一线记者",
    views: 1285000,
    tags: ["网红", "人设崩塌", "私生活", "实锤"],
    featured: true,
    trending: true,
  },
  {
    id: 2,
    slug: "dingji-mingxing-shuiwu-weigui",
    title: "某顶级明星被曝偷税漏税逾亿元 税务部门已介入调查",
    summary: "据知情人士透露，某一线影视明星涉嫌通过阴阳合同等方式偷逃税款，涉及金额超过1.2亿元，目前相关部门已启动调查程序...",
    content: `<p>娱乐圈再次迎来税务风暴。据多位独立信源向51吃瓜爆料网证实，某位活跃于影视圈多年的顶级明星因涉嫌偷逃税款正在接受调查。</p><h2>涉案金额惊人</h2><p>据悉，该明星通过设立多家空壳公司、签订阴阳合同等手段，在过去五年间累计偷逃税款超过1.2亿元人民币。这一数字如果属实，将刷新近年来娱乐圈涉税案件的新纪录。</p><h2>操作手法曝光</h2><p>知情人士透露，该明星团队的操作手法相当隐蔽：通过在不同地区注册多家文化传媒公司，将个人片酬以公司经营收入的形式进行申报，从而规避高额个人所得税。此外，还存在将部分收入转移至境外账户的情况。</p><h2>调查进展</h2><p>目前，税务稽查部门已正式立案，相关调查工作正在紧锣密鼓地进行中。据接近调查组的人士透露，已掌握了大量关键证据。</p><h2>行业震动</h2><p>此消息在娱乐圈内部已引起轩然大波。多位与该明星有合作的导演和制片人表示震惊，部分已紧急调整项目计划以降低风险。</p><p>51吃瓜爆料网将持续追踪此案进展。</p>`,
    category: "mingxing",
    imageSeq: "article-mingxing-01",
    imageQuery: "Dramatic dark scene of celebrity tax investigation concept with blurred luxury items and documents in shadow moody lighting cinematic composition rich textures sophisticated noir style high contrast editorial photography",
    publishedAt: "2026-07-04",
    author: "深度调查组",
    views: 2350000,
    tags: ["明星", "偷税漏税", "调查", "娱乐圈"],
    featured: true,
    trending: true,
  },
  {
    id: 3,
    slug: "zhibo-daihuo-jiahuo-neimu",
    title: "直播带货翻车大揭秘：头部主播卖假货年入过亿",
    summary: "直播带货行业再曝猛料！多名头部主播被指售假，涉及化妆品、奢侈品等多个品类，利润惊人...",
    content: `<p>直播带货的火爆背后，假货问题一直是行业顽疾。近日，一位曾在头部MCN机构工作的前员工向本网独家爆料，揭示了直播带货行业中假货运作的完整产业链。</p><h2>假货产业链揭秘</h2><p>据爆料人透露，部分头部主播背后有着完整的假货供应链体系。从货源采购、包装仿制到直播间话术设计，每一环节都有专业人员负责。</p><h2>利润惊人</h2><p>以一款售价399元的「名牌」护肤品为例，其实际成本仅为30元左右。除去平台抽成和团队分成，主播单场直播的净利润可达数百万元。</p><h2>消费者维权困难</h2><p>由于直播间的商品链接常常在直播结束后下架，消费者发现买到假货后往往面临取证困难、维权无门的窘境。</p><p>本网呼吁相关部门加强监管，保护消费者合法权益。</p>`,
    category: "redian",
    imageSeq: "article-redian-01",
    imageQuery: "Dramatic scene of live streaming ecommerce scandal atmosphere with smartphone showing shopping app dark moody lighting packages and products scattered in shadow cinematic composition investigative journalism style",
    publishedAt: "2026-07-03",
    author: "独家爆料组",
    views: 1890000,
    tags: ["直播带货", "假货", "MCN", "消费者权益"],
    featured: false,
    trending: true,
  },
  {
    id: 4,
    slug: "nv-tuan-chengyuan-bei-ba-ling",
    title: "知名女团成员被霸凌多年 聊天记录流出引爆网络",
    summary: "某当红女团内部霸凌事件浮出水面，一名成员长期遭受队友冷暴力与言语攻击，心理已出现严重问题...",
    content: `<p>光鲜亮丽的偶像团体背后，竟隐藏着令人心痛的故事。近日，一组疑似某知名女团内部聊天记录在网络上流传，揭示了一位成员长期遭受霸凌的事实。</p><h2>霸凌细节</h2><p>根据流出的聊天记录显示，该成员在团队中经常被排挤孤立，日常排练中被故意忽视，甚至在重要演出前被恶意藏匿演出服装。</p><h2>经纪公司沉默</h2><p>事件发酵后，所属经纪公司始终未做出正面回应，仅发布了一条模糊的「内部正在协调」声明，引发粉丝更大不满。</p><h2>网络热议</h2><p>话题#女团霸凌#迅速登上热搜，阅读量突破8亿。大量网友呼吁经纪公司严肃处理此事。</p>`,
    category: "bagua",
    imageSeq: "article-bagua-01",
    imageQuery: "Emotional moody scene of K-pop girl group concept with dramatic shadows and silhouettes dark atmosphere backstage tension cinematic lighting artistic composition contemporary dance studio aesthetic",
    publishedAt: "2026-07-02",
    author: "八卦特派员",
    views: 3560000,
    tags: ["女团", "霸凌", "聊天记录", "爆料"],
    featured: false,
    trending: true,
  },
  {
    id: 5,
    slug: "dahu-shangye-jiaoyi-beihou",
    title: "大主播商业版图曝光：MCN机构背后的资本游戏",
    summary: "深度起底头部主播背后的商业帝国，从签约费到股权结构，揭秘MCN行业的资本运作...",
    content: `<p>当我们在直播间下单时，可能并不了解屏幕那头的主播背后究竟有着怎样复杂的商业架构。本网记者历时三个月调查，为您揭开MCN行业的资本面纱。</p><h2>天价签约费</h2><p>据了解，头部主播的独家签约费用已飙升至千万级别，部分超一线主播的年签约费更是突破亿元大关。</p><h2>复杂的股权结构</h2><p>许多大主播并非单纯签约艺人，而是以合伙人或股东身份深度参与MCN机构的运营，形成利益深度绑定的格局。</p><h2>资本的逐利本质</h2><p>在资本推动下，MCN机构越来越注重短期利润，这导致内容质量下降、造假刷量等问题频发。</p>`,
    category: "shenba",
    imageSeq: "article-shenba-01",
    imageQuery: "Corporate boardroom dramatic scene with documents and money concept dark sophisticated atmosphere business investigation moody lighting cinematic composition high contrast monochromatic tones with warm accent",
    publishedAt: "2026-07-01",
    author: "深度调查组",
    views: 920000,
    tags: ["MCN", "资本", "主播", "商业调查"],
    featured: false,
    trending: false,
  },
  {
    id: 6,
    slug: "shipin-paishedao-luren-gongkai",
    title: "街拍曝光：某明星深夜与神秘女子酒店同出",
    summary: "独家视频曝光！某已婚男星深夜与妙龄女子从酒店并肩走出，举止亲密引发婚变猜测...",
    content: `<p>本网独家获得一段街拍视频，画面中清晰可见某知名已婚男星于深夜时分与一名年轻女子从某五星级酒店并肩走出，两人交谈甚欢，举止颇为亲密。</p><h2>视频细节</h2><p>视频拍摄于本周三晚11时许，该男星身着黑色休闲装，头戴棒球帽，似乎有意遮掩身份。同行的女子身材高挑，穿着一件晚礼服，疑似刚刚参加完某活动。</p><h2>婚变传闻再起</h2><p>这已不是该男星第一次被传出轨。去年就曾有其与女演员的绯闻传出，但当时双方均予以否认。</p><h2>妻子反应</h2><p>据接近其妻子的人士透露，她已知晓此事，但目前情绪稳定，暂未做出公开回应。</p>`,
    category: "shipin",
    imageSeq: "article-shipin-01",
    imageQuery: "Nighttime street photography scene outside luxury hotel with silhouettes and dramatic street lights moody urban atmosphere paparazzi style candid moment cinematic noir aesthetic high contrast cool tones",
    publishedAt: "2026-07-05",
    author: "街拍爆料团",
    views: 4100000,
    tags: ["明星", "出轨", "街拍", "婚变"],
    featured: true,
    trending: true,
  },
  {
    id: 7,
    slug: "wanghong-daihuo-jia-mao-zhengshu",
    title: "网红带货假冒证书被实锤：学历造假惯犯再翻车",
    summary: "带货主播晒出名校毕业证书被网友扒出PS痕迹，经核实该网红最高学历仅为初中...",
    content: `<p>学历造假在网红圈已不是新鲜事，但每次曝光仍能引发巨大关注。近日，一位拥有500万粉丝的带货主播在直播中展示自己的「名校毕业证书」，却被眼尖的网友发现多处PS痕迹。</p><h2>造假细节</h2><p>网友指出的疑点包括：证书上的校长签名与公开资料不符、毕业年份与该校该专业实际开办年份存在矛盾、证书编号格式与该校官方格式不一致等。</p><h2>真实学历曝光</h2><p>经过网友深挖，该网红实际上仅完成了初中学业，从未就读过任何高等院校。</p><h2>商业影响</h2><p>事件曝光后，其直播间人气骤降，多个合作品牌已紧急下架相关推广内容。</p>`,
    category: "wanghong",
    imageSeq: "article-wanghong-02",
    imageQuery: "Dramatic desk scene with fake certificate and magnifying glass revealing forgery dark moody atmosphere investigation concept warm amber key light cinematic composition high detail editorial photography",
    publishedAt: "2026-06-30",
    author: "打假先锋",
    views: 780000,
    tags: ["学历造假", "带货主播", "翻车", "证书"],
    featured: false,
    trending: false,
  },
  {
    id: 8,
    slug: "liangyi-jie-baoguang-yiliao-shigu",
    title: "知名医美机构被曝医疗事故频发 受害者集体维权",
    summary: "某连锁医美机构接连被曝严重医疗事故，多位消费者术后毁容，目前已组成维权联盟...",
    content: `<p>医美行业乱象再次引发关注。近日，全国多地消费者联合举报某知名连锁医美机构，指控其存在无证行医、使用不合格产品等多种违规行为。</p><h2>受害者案例</h2><p>来自杭州的李女士反映，她在该机构做的面部填充手术后出现严重感染，经三甲医院诊断已造成永久性损伤。类似的案例在全国各地还有数十起。</p><h2>维权困难</h2><p>受害者们表示，该医美机构在出事后采取拖延策略，拒绝承担责任，导致维权过程异常艰难。</p><h2>监管介入</h2><p>目前，多地卫健委已对该机构展开调查，部分门店已被责令停业整顿。</p>`,
    category: "redian",
    imageSeq: "article-redian-02",
    imageQuery: "Dramatic medical scene with surgical tools in shadow moody atmosphere healthcare investigation concept cool clinical lighting with warm accent high contrast cinematic style documentary photography",
    publishedAt: "2026-06-28",
    author: "医美调查组",
    views: 1560000,
    tags: ["医美", "医疗事故", "维权", "整形"],
    featured: false,
    trending: false,
  },
  {
    id: 9,
    slug: "xianggang-dingji-yiren-bei-ju-bao",
    title: "香港顶流艺人涉嫌洗钱被举报：涉案金额天文数字",
    summary: "香港娱乐圈再爆大瓜！某顶流艺人被实名举报涉嫌参与跨境洗钱活动，涉案金额高达数十亿港元...",
    content: `<p>香港廉政公署近日收到一份实名举报材料，指认某位在两岸三地都具有极高知名度的香港艺人涉嫌参与大规模跨境洗钱活动。</p><h2>举报内容</h2><p>举报材料详细列出了该艺人通过境外空壳公司、艺术品交易、虚拟货币等多种途径进行资金转移的具体操作流程，时间跨度超过八年。</p><h2>涉案金额</h2><p>根据举报材料，累计涉案金额或超过30亿港元，涉及多个国家和地区。</p><h2>艺人回应</h2><p>该艺人通过律师发表声明，坚决否认所有指控，称这是恶意诽谤，将采取法律手段维护自身权益。</p>`,
    category: "mingxing",
    imageSeq: "article-mingxing-02",
    imageQuery: "Dramatic Hong Kong night scene with financial district skyline luxury and mystery atmosphere dark moody aesthetic cinematic composition with reflections and shadows high contrast urban noir photography",
    publishedAt: "2026-06-25",
    author: "港圈特派员",
    views: 2780000,
    tags: ["香港", "艺人", "洗钱", "举报"],
    featured: true,
    trending: false,
  },
  {
    id: 10,
    slug: "duanshipin-pingtai-neirong-zhengce",
    title: "短视频平台内容审核黑幕：交钱就能过审？",
    summary: "前审核员爆料：某头部短视频平台存在付费审核通道，充值会员的视频可获优先通过...",
    content: `<p>短视频平台的内容审核一直是一个黑箱。近日，一位曾在某头部短视频平台担任内容审核员的爆料者向本网透露了审核流程中的诸多内幕。</p><h2>付费优先</h2><p>据爆料者称，平台设有隐性的付费加速通道，充值会员或购买推广套餐的创作者，其视频会进入快速审核通道，审核标准也明显宽松。</p><h2>双标审核</h2><p>同样的违规内容，普通创作者会被直接下架甚至封号，而头部创作者或付费用户往往只会被限流或口头警告。</p><h2>平台回应</h2><p>截至目前，该平台尚未对上述指控做出正式回应。</p>`,
    category: "shenba",
    imageSeq: "article-shenba-02",
    imageQuery: "Dramatic dark scene of content moderation concept with screens showing social media feeds in shadow moody tech atmosphere surveillance aesthetic cinematic composition high contrast blue hour tones",
    publishedAt: "2026-06-20",
    author: "独家调查组",
    views: 1340000,
    tags: ["短视频", "审核", "黑幕", "内幕"],
    featured: false,
    trending: false,
  },
  {
    id: 11,
    slug: "wangluo-zhubo-bei-qi-pian-ji-qian-wan",
    title: "知名游戏主播被粉丝诈骗数千万 骗子已卷款潜逃",
    summary: "反杀反转！某游戏主播被一名长期铁粉以投资为名骗走全部积蓄，嫌疑人已逃往境外...",
    content: `<p>这次轮到主播成为受害者。某知名游戏主播近日在直播中崩溃痛哭，讲述了自己被一名长期铁粉以合伙投资为由骗走全部积蓄的惨痛经历。</p><h2>诈骗手法</h2><p>据了解，该铁粉通过在直播间长期刷礼物建立了信任关系，随后以内部投资项目为由诱导主播投入资金，初期确有返利，但随后以各种借口要求加码投资。</p><h2>损失惨重</h2><p>该主播累计投入超过3000万元，直到对方彻底失联才意识到被骗。目前警方已介入调查，嫌疑人疑已潜逃至东南亚。</p>`,
    category: "bagua",
    imageSeq: "article-bagua-02",
    imageQuery: "Dramatic gaming room scene with empty chair and scattered money concept dark moody atmosphere deception and betrayal theme cinematic composition warm accent lighting high detail editorial photography",
    publishedAt: "2026-06-18",
    author: "诈骗警示组",
    views: 890000,
    tags: ["游戏主播", "诈骗", "投资", "直播"],
    featured: false,
    trending: false,
  },
  {
    id: 12,
    slug: "jianju-huizhan-baoliao-chigua-quanjilu",
    title: "年度吃瓜全纪录：2026上半年十大最劲爆事件回顾",
    summary: "盘点2026年上半年最让人瞠目结舌的十大吃瓜事件，哪一件最让你震惊？...",
    content: `<p>2026年已经过半，这半年娱乐圈和网红圈可谓是瓜田丰收，从顶流翻车到行业黑幕，每一个瓜都让人吃得津津有味。让我们一起回顾这半年最劲爆的十大事件。</p><h2>第一名：顶流网红人设崩塌</h2><p>2000万粉丝网红被前女友实锤，聊天记录、转账凭证应有尽有，堪称教科书级别的爆料。</p><h2>第二名：顶级明星涉税案</h2><p>亿元级别的偷逃税款让整个娱乐圈为之震动，也再次敲响了依法纳税的警钟。</p><h2>第三名：直播带货假货产业链</h2><p>一条完整的假货产业链被曝光，让无数消费者意识到直播间的优惠背后可能是陷阱。</p>`,
    category: "redian",
    imageSeq: "article-redian-03",
    imageQuery: "Dramatic year in review concept with calendar pages and dramatic lighting moody atmosphere highlights and shadows theme cinematic composition warm golden hour tones artistic documentary photography",
    publishedAt: "2026-07-01",
    author: "编辑部",
    views: 5200000,
    tags: ["年度回顾", "盘点", "吃瓜", "2026"],
    featured: false,
    trending: false,
  },
];

export const testimonials = [
  {
    id: 1,
    name: "资深吃瓜群众",
    role: "社区活跃用户",
    quote: "51吃瓜爆料网的更新速度简直太快了，每次有什么大事发生，这里总是第一个有详细报道的。我已经推荐给身边所有爱吃瓜的朋友了！",
    avatarSeq: "testimonial-01",
    avatarQuery: "Professional portrait of young Asian person with confident expression clean background warm natural lighting editorial style photography modern casual look",
  },
  {
    id: 2,
    name: "匿名爆料人A",
    role: "独家信源",
    quote: "作为一个经常提供线索的爆料人，我选择51吃瓜爆料网是因为他们对信源的保护非常到位，而且发布的内容从不添油加醋，实事求是。",
    avatarSeq: "testimonial-02",
    avatarQuery: "Mysterious silhouette portrait with dramatic backlighting anonymous source concept noir style cinematic atmosphere warm amber rim light professional editorial photography",
  },
  {
    id: 3,
    name: "媒体从业者",
    role: "行业观察者",
    quote: "从专业角度来看，51吃瓜爆料网在娱乐资讯领域的深度和广度都达到了很高的水准。很多独家报道甚至领先于传统媒体。",
    avatarSeq: "testimonial-03",
    avatarQuery: "Professional portrait of Asian journalist in modern newsroom setting warm ambient lighting clean background contemporary editorial style photography",
  },
];

export const faqs = [
  {
    question: "51吃瓜爆料网的内容来源是否可靠？",
    answer: "我们拥有专业的调查团队和广泛的信息网络，所有爆料内容均经过多渠道交叉验证后发布。对于尚未完全证实的信息，我们会明确标注「待核实」标签，确保读者能够区分事实与传闻。",
  },
  {
    question: "如何向平台提供爆料线索？",
    answer: "您可以通过网站底部的「爆料投稿」按钮或发送邮件至 tips@chigua51.com 提供线索。我们承诺对所有爆料人信息严格保密，并根据线索价值提供相应奖励。",
  },
  {
    question: "网站内容每天更新几次？",
    answer: "我们的编辑团队7×24小时不间断工作，确保第一时间为您带来最新爆料。平均每天更新30-50条内容，重大事件发生时更会实时追踪报道。",
  },
  {
    question: "平台有APP可以下载吗？",
    answer: "目前我们的移动端适配已经非常完善，您可以直接在手机浏览器访问网站获得完整体验。独立APP正在开发中，预计年内上线，敬请期待。",
  },
  {
    question: "如何判断哪些是51吃瓜爆料网的原创独家内容？",
    answer: "所有带有「独家」标签的文章均为我网原创内容，由专业调查团队独立采编。我们鼓励转载但请务必注明出处，共同维护良好的网络内容生态。",
  },
  {
    question: "网站是否需要付费才能查看完整内容？",
    answer: "51吃瓜爆料网始终坚持免费开放的运营理念，所有内容均可免费阅读。我们通过广告和品牌合作维持运营，永远不会向读者收费。",
  },
];